import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import "./layout.scss"

const Layout = ({ children }) => (
  <div className="site">
    <div className="ambient" aria-hidden="true" />
    <a className="skip-link" href="#main">
      Skip to content
    </a>
    <Header />
    <main id="main">{children}</main>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
